import { ApiUtility } from "./ApiUtility";

class AudiosService {
  route = "/posts";
  audioRoute = "/api/" + localStorage.getItem("type") + "?lang=";
  categoryRoute = "/api/settings/filters?lang=";
  categoryRouteAudio = "/api/Audios/Categories?lang=";
  pravachanfav = "/api/pravachans/";
  audiofavroute = "/api/audios/";
  pravachanwithid = "/api/Pravachans/";
  dailysatsang = "/api/DailySatsang?lang=";
  years = "/api/Pravachans/yearrange";
  time = "/api/Settings/Time?lang=hindi";
  dailySatsangfavroute = "/api/DailySatsang/"

  getDailySatsang = (
    search: string,
    start: number,
    length: number,
    sort: string,
    month: string,
    year: string,
    authorId: string,
    lyrics: number
  ) => {
    return ApiUtility.get(
      this.dailysatsang +
      localStorage.getItem("lan") +
      "&search=" +
      search +
      "&start=" +
      start +
      "&length=" +
      length +
      "&sort=" +
      sort +
      "&month=" +
      month +
      "&year=" +
      year +
      "&authorId=" +
      authorId +
      "&lyrics=" +
      lyrics
    );
  };

  getPravachanFilters = (productFor: string) => {
    return ApiUtility.get(
      this.categoryRoute +
      localStorage.getItem("lan") +
      "&productFor=" +
      productFor
    );
  };

  getFilters = (productFor: string) => {
    return ApiUtility.get(
      this.categoryRoute +
      localStorage.getItem("lan") +
      "&productFor=" +
      productFor
    );
  };

  getAudioCategories = () => {
    return ApiUtility.get(
      this.categoryRouteAudio + localStorage.getItem("lan")
    );
  };

  getYearReaponse() {
    return ApiUtility.get(this.years + "?ispravachan=true");
  }

  getTimeReaponse() {
    return ApiUtility.get(this.time);
  }

  getAudiosById = (id: string, type: string) => {
    return ApiUtility.get(
      "/api/" + type + "/" + id + "?lang=" + localStorage.getItem("lan")
    );
  };

  // getAudioDetail = (id: string) => {
  //   const lang = localStorage.getItem("lan") || "hindi";
  //   return ApiUtility.get(`${this.kalpatarudetailRoute}${id}/SEO?lang=${lang}`);
  // };

  getAudios = (
    start: number,
    length: number,
    IsChildLiterature: boolean,
    categoryId: string,
    authorId: string,
    search: string,
    sort: string,
    langId: string,
    isSpecial: boolean,
    type: string,
    lyrics: number = 0,
    month: string,
    year: string,
    ptime?: string,
    isOther?: boolean
  ) => {
    if (type === "audios") {
      return ApiUtility.get(
        "/api/" +
        "audios" +
        "?lang=" +
        localStorage.getItem("lan") +
        "&start=" +
        start +
        "&length=" +
        length +
        "&categoryId=" +
        categoryId +
        "&IsChildLiterature=" +
        IsChildLiterature +
        "&authorId=" +
        authorId +
        "&search=" +
        search +
        "&sort=" +
        sort +
        "&lyrics=" +
        lyrics +
        "&audioLangauge=" +
        langId +
        "&isSpecial=" +
        isSpecial
      );
    } else {
      return ApiUtility.get(
        "/api/" +
        "pravachans" +
        "?lang=" +
        localStorage.getItem("lan") +
        "&start=" +
        start +
        "&length=" +
        length +
        "&categoryId=" +
        categoryId +
        "&IsChildLiterature=" +
        IsChildLiterature +
        "&authorId=" +
        authorId +
        "&search=" +
        search +
        "&sort=" +
        sort +
        "&audioLangauge=" +
        langId +
        "&isSpecial=" +
        isSpecial +
        "&lyrics=" +
        lyrics +
        "&month=" +
        month +
        "&year=" +
        year +
        "&ptime=" +
        ptime +
        "&isOther=" +
        isOther
      );
    }
  };

  getaudioandpravachanbyid = (id: string) => {

    if (localStorage.getItem("type") === "audios") {
      return ApiUtility.get(
        this.audiofavroute +
        id +
        "?lang=" +
        localStorage.getItem("lan")
      );
    } else if (localStorage.getItem("type") === "DailySatsang") {
      return ApiUtility.get(
        this.dailySatsangfavroute +
        id +
        "?lang=" +
        localStorage.getItem("lan")
      );
    }
    else {
      return ApiUtility.get(
        this.pravachanwithid +
        id +
        "?lang=" +
        localStorage.getItem("lan")
      );
    }
  };

  addPravachanFavourite = (id: string) => {
    return ApiUtility.post(this.pravachanfav + id + "/favourite", {});
  };

  removePravachanFaviourite = (id: string) => {
    return ApiUtility.delete(this.pravachanfav + id + "/favourite");
  };

  addAudioFavourite = (id: string) => {
    return ApiUtility.post(this.audiofavroute + id + "/favourite", {});
  };

  removeAudioFavourite(id: string) {
    return ApiUtility.delete(this.audiofavroute + id + "/favourite");
  }

  addDailySatsangFavourite = (id: string) => {
    return ApiUtility.post(this.dailySatsangfavroute + id + "/favourite", {});
  };

  removeDailySatsangFavourite(id: string) {
    return ApiUtility.delete(this.dailySatsangfavroute + id + "/favourite");
  }

}
export default new AudiosService();
